import { IPromise, IQService } from 'angular';

export class CropImageService {
  static $inject = [
    '$q'
  ];

  constructor( private $q: IQService ) {
  }

  convertFileToDataURI( file: File ): IPromise<string> {
    return this.$q(( resolve, reject ) => {
      const reader = new FileReader();
      reader.onload = ( event: any ) => {
        resolve(event.target.result);
      };
      reader.onerror = ( error ) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  }

  convertDataURIToFile( dataURI: string, filename: string ): IPromise<File> {
    return this.$q(( resolve ) => {
      const byteString = atob(dataURI.split(',')[ 1 ]);
      // separate out the mime component
      const mimeType = dataURI.split(',')[ 0 ].split(':')[ 1 ].split(';')[ 0 ];

      // write the bytes of the string to an ArrayBuffer
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for ( let i = 0; i < byteString.length; i++ ) {
        ia[ i ] = byteString.charCodeAt(i);
      }
      // write the ArrayBuffer to a blob, and you're done
      const blob = new Blob([ ab ], { type: mimeType });
      resolve(new File([ blob ], this.getFilenameWithoutExt(filename), { type: blob.type }));
    });
  }

  private getFilenameWithoutExt( filename: string ): string {
    const extDotIndex = filename.lastIndexOf('.');
    return filename.slice(0, extDotIndex);
  }
}



// WEBPACK FOOTER //
// ./app/components/modals/crop-image-modal/services/crop-image.service.ts